import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
  return (
    <div className="main">
      {/* Header start */}
      <header id="header">
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-3 col-md-4 col-8 p-0">
              <div className="navbar-header" style={{paddingLeft: '0'}}>
                <Link className="navbar-brand" to="/">
                  <img alt="dptech" src="images/dptech_logo_white.png" style={{height: '60px'}} />
                </Link> 
              </div>
            </div>
            <div className="col-lg-9 col-md-8 col-4 p-0">
              <button data-target=".navbar-collapse" data-toggle="collapse" className="navbar-toggle d-block d-lg-none d-xl-none" type="button">
                <i className="fa fa-bars"></i>
              </button>
              <div className="overlay"></div>
              <div id="menu" className="navbar-collapse collapse">
                <ul className="nav navbar-nav">
                  <li className="level">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="level">
                    <Link to="/#data-solutions-part">Data solutions</Link>
                  </li>
                  <li className="level">
                    <Link to="/#cloud-part">Cloud</Link>
                  </li>
                  <li className="level">
                    <Link to="/#use-cases-part">Use case</Link>
                  </li>
                  <li className="level">
                    <Link to="/about">About</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Header end */}

      {/* Navbar Background Space */}
      <div style={{background: '#1a1a1a', height: '140px'}}></div>

      {/* Privacy Policy Content */}
      <section style={{padding: '30px 0 40px 0', background: '#fff'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="policy-content" style={{lineHeight: '1.8', color: '#333', textAlign: 'left'}}>
                
                {/* Page Title */}
                <div className="page-title" style={{textAlign: 'center', marginBottom: '50px'}}>
                  <h1 style={{color: '#1a1a1a', fontSize: '36px', fontWeight: '600', marginBottom: '15px', fontFamily: "'Poppins', sans-serif"}}>Privacy Policy</h1>
                  <div style={{width: '80px', height: '4px', background: 'linear-gradient(135deg, #FFD84D 0%, #FFA500 100%)', margin: '0 auto', borderRadius: '2px'}}></div>
                </div>
                
                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>1. Informativa Web Privacy</h2>
                  <p style={{marginBottom: '15px'}}>
                    <strong>AI SENSI DELL'ARTICOLO 13 DEL REGOLAMENTO EU 2016/679 E DEL D.LGS. 196/2016</strong>
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    Con la presente La informiamo che dal 25 maggio 2018 è entrato in vigore il regolamento UE 2016/679 (c.d. GDPR) 
                    che integra e sostituisce in parte il d.lgs. 196/2003 denominato Codice in materia di protezione per i dati personali. 
                    Il regolamento europeo all'articolo 1 prescrive che lo stesso "protegge i diritti e libertà fondamentali delle persone fisiche, 
                    in particolare il diritto alla protezione dei dati personali".
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    Per coloro che accedono dall'indirizzo del nostro sito web. Si precisa che la presente informativa riguarda solo il presente 
                    sito e non anche altri indirizzi web eventualmente consultati dall'utente tramite link. In particolare, al di là della vigente 
                    normativa su menzionata.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>2. Titolarità del Trattamento</h2>
                  <p style={{marginBottom: '15px'}}>
                    Il titolare del trattamento dei dati, relativi a persone identificate o identificabili che accedono a questo sito, 
                    vi navigano anche registrandosi sullo stesso, è la società <strong>dpTech</strong>, con sede legale in via Daimler, 8 - 20151 Milano (MI), Italia. 
                    Per contatti inviare lettera alla sede indicata oppure utilizzare l'email: <strong>info@dptech.io</strong>.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    In osservanza del regolamento europeo 2016/679, inoltre, lei potrà rivolgere le sue richieste relative all'esercizio 
                    dei suoi diritti all'attenzione del Responsabile della protezione dei dati personali tramite la seguente email: <strong>info@dptech.io</strong>.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>3. Finalità del Trattamento che Non Necessitano del Consenso dell'Utente</h2>
                  <p style={{marginBottom: '15px'}}>
                    La informiamo che i dati personali da Lei forniti, come il Suo nominativo e la Sua email, potranno essere trattati per:
                  </p>
                  <ul style={{marginBottom: '20px', paddingLeft: '20px'}}>
                    <li style={{marginBottom: '8px'}}>rispondere alla Sue richieste;</li>
                    <li style={{marginBottom: '8px'}}>provvedere alla registrazione alla nostra newsletter;</li>
                    <li style={{marginBottom: '8px'}}>ottemperare agli obblighi previsti dalla legge, da regolamenti o normative comunitarie.</li>
                  </ul>
                  <p style={{marginBottom: '15px'}}>
                    Queste <strong>FINALITÀ</strong> non necessitano del Suo consenso ai sensi dell'art. 7 del regolamento UE 2016/679 e del d.lgs 196/2003, 
                    ma vi richiediamo di inserire una spunta di presa visione della presente informativa presente sul nostro sito.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>4. Conferimento dei Dati</h2>
                  <p style={{marginBottom: '15px'}}>
                    Il conferimento dei Suoi dati personali per le finalità indicate sopra è facoltativo; il loro mancato, parziale o inesatto 
                    conferimento potrebbe tuttavia avere come conseguenza l'impossibilità di svolgere le attività ivi specificate.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    I dati personali (nome ed email) relativi agli utenti registrati alla newsletter saranno conservati per tutto il periodo di registrazione, 
                    qualora un account sia rimasto disattivo per un periodo di 12 mesi consecutivi verrà disattivato e successivamente cancellato.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>5. Modalità del Trattamento - Ambito di Comunicazione e Conservazione dei Dati</h2>
                  <p style={{marginBottom: '15px'}}>
                    I dati personali sono trattati con strumenti automatizzati per il tempo strettamente necessario a conseguire gli scopi per cui sono stati raccolti. 
                    I suoi dati personali potranno essere comunicati solo a responsabile e personale autorizzato. Specifiche misure di sicurezza sono osservate per 
                    prevenire la perdita dei dati, usi illeciti o non corretti ed accessi non autorizzati e la disponibilità dei suoi dati.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    I dati personali relativi agli utenti registrati saranno conservati per tutto il periodo di registrazione, qualora un account sia rimasto 
                    disattivo per un periodo di 12 mesi consecutivi verrà disattivato e successivamente cancellato.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>6. Luogo di Trattamento dei Dati</h2>
                  <p style={{marginBottom: '15px'}}>
                    I dati relativi alle persone che accedono a questo sito e vi navigano sono trattati presso le rispettive sedi del titolare del trattamento, 
                    dal loro personale autorizzato al trattamento, oppure dai responsabili per compiere operazioni di manutenzione adeguatamente formati sulla 
                    tutela della riservatezza.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    Nessun dato derivante dall'accesso a questo sito ed alla navigazione in esso viene comunicato o diffuso. I dati personali eventualmente 
                    forniti da coloro che accedono all'area riservata ai contatti e/o alle richieste di qualsiasi natura sono utilizzati unicamente per la 
                    richiesta inviata e sono comunicati a terzi nel solo caso in cui ciò fosse necessario.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>7. Dati Trattati - Dati di Navigazione</h2>
                  <p style={{marginBottom: '15px'}}>
                    L'accesso al presente sito e la navigazione all'interno di esso avviene mediante l'utilizzo di un browser web. Si riporta quanto contenuto 
                    nella predetta Raccomandazione (n. 2/2001): "I browser sono programmi di software progettati, tra l'altro, per visualizzare graficamente 
                    il materiale disponibile su Internet. I browser comunicano tra il computer dell'utente (cliente) ed il computer a distanza in cui sono 
                    memorizzate le informazioni (web server). I browser spesso trasmettono al web server più informazioni di quelle strettamente necessarie 
                    per stabilire la comunicazione. I browser classici trasmetteranno automaticamente al web server visitato il tipo ed il linguaggio del browser, 
                    il nome degli altri programmi software installati sul PC dell'utente ed il sistema operativo, la pagina di riferimento, i cookies, ecc.".
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    Alcuni dati necessari per la navigazione in internet, per loro stessa natura, potrebbero permettere di identificare gli utenti attraverso 
                    elaborazioni ed associazioni con dati detenuti da terzi. In particolare s'intende riferirsi agli indirizzi IP o ai nomi a dominio dei 
                    computer utilizzati dagli utenti che si connettono a questo sito, gli indirizzi in notazione URI (Uniform Resource Identifier) delle 
                    risorse richieste, l'orario della richiesta, ecc.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    Tali dati vengono utilizzati al solo fine di ricavare informazioni statistiche anonime sull'uso del sito e per controllarne il corretto 
                    funzionamento e vengono cancellati immediatamente dopo l'elaborazione. I dati potrebbero essere utilizzati per eventuali responsabilità 
                    nell'ipotesi di reati informatici connessi con questo sito. I dati relativi a coloro che hanno inoltrato richieste allo studio per via 
                    telematica utilizzando gli strumenti presenti su questo sito sono conservati per non più di cinque giorni e comunque per il tempo necessario 
                    ad inoltrare le risposte.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>8. Dati Forniti Volontariamente dall'Utente</h2>
                  <p style={{marginBottom: '15px'}}>
                    L'invio facoltativo, esplicito e volontario di posta elettronica agli indirizzi indicati su questo sito comporta l'acquisizione dell'indirizzo 
                    del mittente, nei limiti delle finalità del trattamento sopra indicate.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>9. Cookies</h2>
                  <p style={{marginBottom: '15px'}}>
                    La Raccomandazione su indicata (n. 2/2001) definisce i cookies come "una registrazione informatica di d'informazioni trasmessa da un web 
                    server ad un computer dell'utente per la futura identificazione di tale computer al momento di future visite allo stesso sito web". 
                    A tal proposito si precisa che attraverso i c.d. cookies di sessione (non memorizzati) non viene acquisito nessun dato personale dell'utente 
                    il quale accede a questo sito o vi naviga.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    Si precisa, altresì, che l'uso dei cookies di sessione (costituiti da numeri casuali generati dal server) si rende necessario unicamente 
                    per consentire l'esplorazione sicura ed efficiente del sito. Non si utilizzano cookies per trasmettere dati personali, né per ipotesi di 
                    tracciamento dell'utente.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    Per informazioni dettagliate sui cookie utilizzati, consulta la nostra{' '}
                    <Link to="/cookies" style={{color: '#FFD84D', textDecoration: 'underline'}}>
                      Cookie Policy
                    </Link>.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>10. Diritti dell'Interessato, Diritto alla Portabilità - Diritto al Reclamo</h2>
                  <p style={{marginBottom: '15px'}}>
                    A Lei in qualità di interessato sono riconosciuti degli specifici diritti, quali: la conferma dell'esistenza o meno di dati personali che 
                    la riguardano presso il titolare del trattamento, anche se non ancora registrati, e la loro comunicazione in forma intelligibile; il diritto 
                    di ottenere l'indicazione dell'origine dei dati personali e delle finalità e modalità del trattamento elettronico e/o cartaceo; degli estremi 
                    identificativi del titolare, e degli eventuali responsabili ai sensi dell'art. 28 del regolamento; l'aggiornamento, la rettificazione ovvero, 
                    quando vi abbia interesse, l'integrazione dei dati; la cancellazione degli stessi.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    L'interessato ha diritto di opporsi, in tutto o in parte per motivi legittimi al trattamento dei dati personali che lo riguardano, ancorché 
                    pertinenti allo scopo della raccolta ed al trattamento di dati personali che lo riguardano. Oltre ai diritti sopra elencati in qualità di 
                    interessato, nei limiti di quanto previsto dal nuovo regolamento europeo, lei potrà esercitare anche i diritti di limitazione del trattamento, 
                    di opposizione allo stesso ed il diritto alla portabilità esclusivamente per i dati personali da lei forniti al titolare del trattamento 
                    secondo l'art. 20 del regolamento citato.
                  </p>
                  <p style={{marginBottom: '15px'}}>
                    La informiamo inoltre che in base al Codice della Privacy e al nuovo regolamento europeo potrete proporre azioni a tutela dei vostri diritti 
                    innanzi al Garante per la protezione dei dati personali oppure un ricorso all'Autorità giurisdizionale, c.d. reclamo previsto dall'art. 77 
                    del predetto regolamento. Si informa infine che nei limiti nei quali sarà ritenuto applicabile al trattamento dei dati che la riguarda potrà 
                    esercitare un diritto di revoca del consenso al trattamento dei dati comunicando tale revoca al titolare del trattamento.
                  </p>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>11. Contatti</h2>
                  <p style={{marginBottom: '15px'}}>
                    Per esercitare i tuoi diritti o per qualsiasi domanda sulla privacy, contattaci:
                  </p>
                  <div style={{background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '1px solid #e9ecef', marginTop: '15px'}}>
                    <p style={{marginBottom: '8px'}}><strong>Email:</strong> info@dptech.io</p>
                    <p style={{marginBottom: '8px'}}><strong>Indirizzo:</strong> Milano, Italia</p>
                    <p style={{marginBottom: '0'}}><strong>Responsabile della Protezione dei Dati:</strong> dpTech Team</p>
                  </div>
                </div>

                <div className="policy-section" style={{marginBottom: '40px'}}>
                  <h2 style={{color: '#1a1a1a', fontSize: '24px', fontWeight: '600', marginBottom: '20px', borderBottom: '2px solid #FFD84D', paddingBottom: '10px'}}>12. Aggiornamenti della Policy</h2>
                  <p style={{marginBottom: '15px'}}>
                    Questa Privacy Policy può essere aggiornata periodicamente per riflettere cambiamenti nella nostra pratica di gestione dei dati 
                    o per conformarci a nuove normative. Ti informeremo di eventuali modifiche significative attraverso il nostro sito web.
                  </p>
                  <p style={{marginBottom: '0'}}>
                    <strong>Ultimo aggiornamento:</strong> {new Date().toLocaleDateString('it-IT')}
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer section start */}
      <footer style={{background: '#f8f9fa', color: '#555', padding: '60px 0 20px 0', marginTop: 0}}>
        <div className="container">
          <div className="row">
            {/* Company Info */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <img src="images/dpTech_logo_1916x710_300dpi_RGB_transparent.png" alt="dpTech" style={{height: '40px', marginBottom: '15px'}} />
                <p style={{color: '#555', lineHeight: '1.5', marginBottom: '15px', fontSize: '14px'}}>
                  dpTech è il tuo partner per l'innovazione. Trasformiamo i dati in valore per il tuo business.
                </p>
              </div>
            </div>
            
            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Servizi</h5>
                <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#data-solutions-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Data Solutions</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#cloud-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Cloud</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/#use-cases-part" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Use Cases</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/about" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Chi Siamo</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Legal & Contact */}
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Informazioni</h5>
                <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/privacy" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Privacy Policy</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/cookies" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Cookies Policy</Link>
                  </li>
                  <li style={{marginBottom: '8px'}}>
                    <Link to="/about" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease', fontSize: '14px'}}>Contattaci</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Contact Info */}
            <div className="col-lg-3 col-md-6 mb-3">
              <div className="footer-section" style={{textAlign: 'left'}}>
                <h5 style={{color: '#555', marginBottom: '15px', fontWeight: '600', fontSize: '16px'}}>Contatti</h5>
                <div style={{color: '#555', lineHeight: '1.5'}}>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <i className="fas fa-envelope" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                    info@dptech.io
                  </p>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <i className="fas fa-map-marker-alt" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                    Milano, Italia
                  </p>
                  <p style={{marginBottom: '8px', fontSize: '14px'}}>
                    <a href="https://www.linkedin.com/company/dptech-io" target="_blank" rel="noopener noreferrer" style={{color: '#555', textDecoration: 'none', transition: 'color 0.3s ease'}}>
                      <i className="fab fa-linkedin" style={{marginRight: '8px', color: '#FFD84D'}}></i>
                      LinkedIn
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Footer Bottom */}
          <div className="footer-bottom" style={{borderTop: '1px solid #dee2e6', paddingTop: '20px', marginTop: '20px'}}>
            <div className="row align-items-center">
              <div className="col-6 text-left">
                <p style={{color: '#555', margin: 0, fontSize: '13px', lineHeight: '1.4'}}>
                  © 2025 dpTech | Data Solutions. Tutti i diritti riservati.<br />
                  P.IVA: 14159740969
                </p>
              </div>
              <div className="col-6 text-right">
                <div style={{color: '#555', fontSize: '11px', lineHeight: '1.3'}}>
                  <p style={{margin: 0, fontStyle: 'italic', fontFamily: "'Poppins', sans-serif"}}>
                    dptech.io si impegna a seguire le linee guida WCAG 2.1 AA, e a rendere il proprio sito web accessibile.{' '}
                    <a href="/files/Dichiarazione di accessibilita.pdf" target="_blank" rel="noopener noreferrer" style={{color: '#555', textDecoration: 'underline'}}>Dichiarazione di accessibilità</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* Footer section end */}
    </div>
  );
}

export default PrivacyPolicy;
